import React, { useEffect, useState } from "react";

import { useTranslation } from "utils";

import { BLANK_PESTICIDE } from "consts";

import { PesticidesForm } from "pages/app/modules/components/Pesticide/PesticidesForm";

export const PesticidesBaselineYear = ({ existingPesticides, forms, year, onUpdate }) => {
  const { t } = useTranslation(["modules"]);
  const defaultPesticides = existingPesticides || [BLANK_PESTICIDE()];
  const [pesticides, setPesticides] = useState(defaultPesticides);

  useEffect(() => {
    forms.current[year] = forms.current[year].slice(0, pesticides.length);
  }, [forms, pesticides, year]);

  const updatePesticide = (index, v) => {
    const pesticidesCopy = [...pesticides];
    pesticidesCopy[index] = {
      id: pesticidesCopy[index].id,
      key: pesticidesCopy[index].key,
      ...v,
    };
    setPesticides(pesticidesCopy);
    onUpdate("pesticides", year, pesticidesCopy);
  };

  return (
    <div className="baseline-form margin-bottom-400">
      <div className="fertilizer-bau-form">
        <div className="baseline-year-header-row">
          <h2>{year}</h2>
        </div>

        {pesticides.length ? (
          pesticides.map((pesticide, index) => (
            <div key={index}>
              <PesticidesForm forms={forms} index={index} pesticide={pesticide} year={year} onUpdate={updatePesticide} />
            </div>
          ))
        ) : (
          <p className="margin-bottom-200">{t("bauEntryDrawer.pesticides.noneApplied")}</p>
        )}
      </div>
    </div>
  );
};
